module.exports = __webpack_public_path__ + "img/cn-pro-j.60f8893b.png";